import { render, staticRenderFns } from "./InitializeClassTuition.vue?vue&type=template&id=0003549a&scoped=true"
import script from "./InitializeClassTuition.vue?vue&type=script&lang=js"
export * from "./InitializeClassTuition.vue?vue&type=script&lang=js"
import style0 from "./InitializeClassTuition.vue?vue&type=style&index=0&id=0003549a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0003549a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0003549a')) {
      api.createRecord('0003549a', component.options)
    } else {
      api.reload('0003549a', component.options)
    }
    module.hot.accept("./InitializeClassTuition.vue?vue&type=template&id=0003549a&scoped=true", function () {
      api.rerender('0003549a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionManagement/InitializeClassTuition.vue"
export default component.exports